export default "__VITE_ASSET__LFFnIwfU__"